import script from "./HowItWorksButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksButton.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorksButton.vue?vue&type=style&index=0&id=696ec583&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696ec583"]])

export default __exports__